
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/storico-neve",
      function () {
        return require("private-next-pages/[region]/[resort]/storico-neve.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/storico-neve"])
      });
    }
  